{
  "settings": {
    "title": "Impostazioni account",
    "subtitle": "Gestisci email, password e stato dell'account.",
    "needHelp": "Hai bisogno di aiuto? Unisciti al nostro Discord"
  },
  "changeEmail": {
    "title": "Cambia indirizzo email",
    "subtitle": "Cambiando la tua email dovrai riconfermare l'indirizzo. Sarai disconnesso da tutte le sessioni.",
    "newEmailLabel": "Nuovo indirizzo email",
    "newEmailPlaceholder": "Inserisci nuova email",
    "currentPasswordLabel": "Password attuale",
    "currentPasswordPlaceholder": "Inserisci la password attuale",
    "submitButton": "Aggiorna indirizzo email",
    "submittingButton": "Aggiornamento..."
  },
  "changePassword": {
    "title": "Cambia password",
    "subtitle": "Aggiorna la tua password. Rimarrai connesso su questo dispositivo.",
    "currentPasswordLabel": "Password attuale",
    "currentPasswordPlaceholder": "Inserisci la password attuale",
    "newPasswordLabel": "Nuova password",
    "newPasswordPlaceholder": "Inserisci la nuova password",
    "confirmPasswordLabel": "Conferma nuova password",
    "confirmPasswordPlaceholder": "Conferma la nuova password",
    "submitButton": "Cambia password",
    "submittingButton": "Aggiornamento..."
  },
  "closeAccount": {
    "title": "Chiudi account",
    "subtitle": "Disattiva definitivamente il tuo account. Se hai un abbonamento attivo, verrà annullato. Questa azione non può essere facilmente annullata.",
    "openButton": "Voglio chiudere il mio account",
    "warning": "⚠️ Attenzione: questa operazione disattiverà il tuo account, annullerà qualsiasi abbonamento attivo, ti disconnetterà da tutte le sessioni e non rimborseremo gli abbonamenti annullati. I tuoi dati verranno conservati ma il tuo account sarà inaccessibile.",
    "passwordLabel": "La tua password",
    "passwordPlaceholder": "Inserisci la tua password",
    "confirmLabel": "Digita",
    "confirmCode": "CHIUDI IL MIO ACCOUNT",
    "confirmLabelEnd": "per confermare",
    "confirmPlaceholder": "CHIUDI IL MIO ACCOUNT",
    "cancelButton": "Annulla",
    "submitButton": "Chiudi account definitivamente",
    "submittingButton": "Chiusura..."
  },
  "contactUs": {
    "title": "Contattaci",
    "body": "Contattaci all'indirizzo",
    "discordName": "Flipping Pal Discord",
    "bodyEnd": "oppure unisciti alla nostra community Discord per domande."
  }
}
